import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowRightIcon, BellPlusIcon, CheckIcon, ChevronRightIcon, HeartIcon, MapPinIcon, PawPrintIcon } from 'lucide-react';
import { PetCard } from '../components/animaux/PetCard';
import { LostFlow } from '../components/animaux/LostFlow';
import { PetRules } from '../components/animaux/PetAtna';
import { VetConnect } from '../components/animaux/VetConnect';
import { petReminders, petTodos, pets, sightings, sourceLabels } from '../data/animaux';
export function AnimalDetail() {
  const {
    id
  } = useParams();
  const pet = pets.find(item => item.id === id) ?? pets[0];
  const [lost, setLost] = useState(false);
  const [flowOpen, setFlowOpen] = useState(false);
  const [found, setFound] = useState(false);
  const todos = petTodos[pet.id] ?? [];
  const reminders = petReminders[pet.id] ?? [];
  return <main className="bg-white" data-id="element-1827" data-mp="1ezt8h3snuv1j">
      <div className="mx-auto max-w-[1000px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-1828" data-mp="1eyzyltyenpf6">
        <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-1.5 text-sm text-slate-500" data-id="element-1829" data-mp="2jm5vgqgd9a1g">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-1830" data-mp="2eodruz6czzhf">
            Home
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1831" data-mp="2tjjxvm5gfyar" />
          <Link to="/my-pets" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-1832" data-mp="2ol8o1bf5tnsj">
            My pets
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1833" data-mp="20wpgwz7ujh21" />
          <span aria-current="page" data-id="element-1834" data-mp="1vxw4zb87jy3z">{pet.name}</span>
        </nav>

        <div className="mt-6 grid gap-10 lg:grid-cols-[minmax(0,520px)_minmax(0,1fr)] lg:gap-12" data-id="element-1835" data-mp="2am0nof79g9mr">
          <div data-id="element-1836" data-mp="25vaj346nsat4">
            <PetCard pet={pet} lost={lost} data-id="element-1837" data-mp="25ur0rmd3jkek" />

            {!lost ? <button type="button" onClick={() => setFlowOpen(true)} className="mt-3 inline-flex items-center gap-2 rounded-full border border-slate-200 px-5 py-2.5 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-red-600 hover:text-red-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1838" data-mp="25tzh99wrxd4n">
                <PawPrintIcon className="h-4 w-4" aria-hidden="true" data-id="element-1839" data-mp="26vkh4ju5iei8" />
                Report {pet.name} missing
              </button> : <button type="button" onClick={() => {
            setLost(false);
            setFound(true);
          }} className="mt-3 inline-flex items-center gap-2 rounded-full bg-ville-navy px-5 py-2.5 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1840" data-mp="2bodqjl0keb0n">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-1841" data-mp="1sv01txng30th" />
                {pet.name} is home
              </button>}
          </div>

          <div data-id="element-1842" data-mp="34bq7nfnyhqmk">
            {found && <div className="mb-6 flex items-start gap-3 rounded-2xl bg-ville-indigo-soft px-5 py-4" data-id="element-1843" data-mp="34cj85ywbnjw9">
                <HeartIcon className="mt-0.5 h-5 w-5 shrink-0 text-ville-indigo" aria-hidden="true" data-id="element-1844" data-mp="399rso64y000o" />
                <div data-id="element-1845" data-mp="xmfyb5s3g5z9">
                  <p className="font-bold text-ville-navy" data-id="element-1846" data-mp="xmxyuelsh6cz">{pet.name} is home</p>
                  <p className="text-sm text-slate-600" data-id="element-1847" data-mp="spphuhcdn8db">
                    The community alert has been closed. Thank you to the residents who helped.
                  </p>
                </div>
              </div>}

            {lost && <section aria-labelledby="missing-title" className="mb-8 overflow-hidden rounded-3xl border border-slate-200" data-id="element-1848" data-mp="iybcvu1npgcs">
                <div className="border-l-4 border-red-600 p-6" data-id="element-1849" data-mp="9xwnojlknh40">
                  <span className="inline-flex rounded-full bg-red-600 px-3 py-1 text-xs font-bold uppercase tracking-wider text-white" data-id="element-1850" data-mp="9wbwn3ygugaw">
                    Missing
                  </span>
                  <h2 id="missing-title" className="mt-3 text-xl font-extrabold text-ville-navy" data-id="element-1851" data-mp="10m6xu3bv8y">
                    {pet.name} is currently reported missing.
                  </h2>
                  <p className="mt-1 text-sm text-slate-600" data-id="element-1852" data-mp="1uet9bu597izf">
                    Community notice sent · 1.5 km radius · no personal information shared.
                  </p>

                  <div className="relative mt-5 h-40 overflow-hidden rounded-2xl bg-slate-100" data-id="element-1853" data-mp="27e2fg4461mno">
                    <div className="absolute inset-0 opacity-60 [background-image:linear-gradient(#cbd5e1_1px,transparent_1px),linear-gradient(90deg,#cbd5e1_1px,transparent_1px)] [background-size:28px_28px]" data-id="element-1854" data-mp="1sgic11mx3zjm" />
                    <div className="absolute left-1/2 top-1/2 h-28 w-28 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-ville-indigo bg-ville-indigo/10" data-id="element-1855" data-mp="1jnol26y3zbpx" />
                    <span className="absolute left-1/2 top-1/2 h-3 w-3 -translate-x-1/2 -translate-y-1/2 rounded-full bg-ville-indigo" data-id="element-1856" data-mp="19psc9lsn8suz" />
                  </div>
                  <p className="mt-2 text-xs text-slate-500" data-id="element-1857" data-mp="1epdaftzzox6n">
                    Last known location and search area — this is not {pet.name}’s current position.
                  </p>

                  <h3 className="mt-6 text-sm font-bold uppercase tracking-wider text-slate-500" data-id="element-1858" data-mp="14pmi9yywiu9q">Recent sightings</h3>
                  <ol className="mt-3 space-y-3" data-id="element-1859" data-mp="m2x1m4q61rsl">
                    {sightings.map(sighting => <li key={sighting.time} className="flex gap-3 text-sm" data-id="element-1860" data-mp="h4c2y9qkbg69">
                        <span className="w-16 shrink-0 font-semibold text-slate-500" data-id="element-1861" data-mp="v3l90gl20twi">{sighting.time}</span>
                        <span data-id="element-1862" data-mp="q3pct3ilm6ri">
                          <span className="block font-bold text-ville-navy" data-id="element-1863" data-mp="q2ffwhnhf4mg">{sighting.label}</span>
                          <span className="flex items-center gap-1 text-slate-500" data-id="element-1864" data-mp="14zoh032l7mrd">
                            <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1865" data-mp="101dbu5n8m0fh" />
                            {sighting.place}
                          </span>
                        </span>
                      </li>)}
                  </ol>
                </div>
              </section>}

            <section aria-labelledby="pet-todo-title" data-id="element-1866" data-mp="1nqxrofo3ghkj">
              <h2 id="pet-todo-title" className="text-xl font-extrabold tracking-tight text-ville-navy" data-id="element-1867" data-mp="1npeb0nyj04i8">
                To do
              </h2>
              {todos.length === 0 ? <p className="mt-2 flex items-center gap-2 text-sm text-slate-500" data-id="element-1868" data-mp="ggt4tlr0s9ul">
                  <CheckIcon className="h-4 w-4 text-ville-indigo" aria-hidden="true" data-id="element-1869" data-mp="khmr6aotdgld" />
                  Everything is up to date.
                </p> : <ul className="mt-4 space-y-3" data-id="element-1870" data-mp="pdtq3jislrtt">
                  {todos.map(todo => <li key={todo.id} className="rounded-2xl border border-slate-200 px-5 py-4" data-id="element-1871" data-mp="u7ekz2p3a5os">
                      <p className="text-[15px] font-bold text-ville-navy" data-id="element-1872" data-mp="z4y1k999eujw">{todo.title}</p>
                      <p className="mt-0.5 text-sm text-slate-600" data-id="element-1873" data-mp="143rcpv12q9gw">{todo.detail}</p>
                      <button type="button" className="mt-3 inline-flex items-center gap-2 rounded-full bg-ville-navy px-5 py-2 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1874" data-mp="18660mtjlnzf1">
                        {todo.cta}
                        <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1875" data-mp="3eyotl34a96ea" />
                      </button>
                    </li>)}
                </ul>}
            </section>

            <section aria-labelledby="pet-reminders-title" className="mt-10" data-id="element-1876" data-mp="32lbfyydwbdru">
              <div className="flex flex-wrap items-center justify-between gap-3" data-id="element-1877" data-mp="2xobaaokykd19">
                <h2 id="pet-reminders-title" className="text-xl font-extrabold tracking-tight text-ville-navy" data-id="element-1878" data-mp="2sp84h1x5m2s8">
                  Reminders
                </h2>
                <button type="button" className="inline-flex items-center gap-2 rounded-full border border-slate-200 px-4 py-2 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1879" data-mp="3ld48krp1ywz1">
                  <BellPlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-1880" data-mp="24z4azndojjey" />
                  Add a reminder
                </button>
              </div>
              <ul className="mt-4 space-y-2" data-id="element-1881" data-mp="20zdcsyltq10e">
                {reminders.map(reminder => <li key={reminder.id} className="flex flex-wrap items-baseline justify-between gap-2 rounded-2xl bg-slate-50 px-5 py-3" data-id="element-1882" data-mp="3vv3gitkqaf8">
                    <span data-id="element-1883" data-mp="8td3tktizhbm">
                      <span className="block text-[15px] font-bold text-ville-navy" data-id="element-1884" data-mp="3r1vqqg4jvgh5">{reminder.label}</span>
                      <span className="block text-xs text-slate-500" data-id="element-1885" data-mp="3vznjtdgxl8mx">{sourceLabels[reminder.source]}</span>
                    </span>
                    <span className="text-sm text-slate-600" data-id="element-1886" data-mp="nl5h7r9relap">{reminder.date}</span>
                  </li>)}
              </ul>
              <p className="mt-3 text-xs text-slate-500" data-id="element-1887" data-mp="ro1tl08phl67">
                Reminders and changes appear under{' '}
                <Link to="/notifications" className="font-bold text-ville-indigo hover:underline" data-id="element-1888" data-mp="itx6mrwp0tvy">
                  Notifications
                </Link>
                . The renewal invoice is filed under{' '}
                <Link to="/my-profile" className="font-bold text-ville-indigo hover:underline" data-id="element-1889" data-mp="1baq1qelk9qm3">
                  My Profile → My Invoices
                </Link>
                .
              </p>
            </section>
          </div>
        </div>

        <PetRules data-id="element-1890" data-mp="1gmwrnrxxe7nm" />
        <VetConnect data-id="element-1891" data-mp="1glbx42bm2opr" />
      </div>

      <LostFlow pet={pet} open={flowOpen} onClose={() => setFlowOpen(false)} onConfirm={() => {
      setFlowOpen(false);
      setLost(true);
      setFound(false);
    }} data-id="element-1892" data-mp="1ufcogb08h9g3" />
    </main>;
}